import { Injectable } from '@angular/core';
import { AreYouSureComponent } from './../are-you-sure/are-you-sure.component';
import { MatDialog } from '@angular/material';

@Injectable()
export class AreYouSureService {

  constructor(private dialog: MatDialog) {}


  areYouSure(callBackFunction) {

    const areYouSure = this.dialog.open(AreYouSureComponent, {
      width: '250px',
      height: '150px'
    });


    areYouSure.afterClosed().subscribe(result => {
      if (result === true) {
        callBackFunction();
      }
    });
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-services/are-you-sure.service.ts